export const TEAMS = ["Platform", "CoCo", "ShareSquad", "StatSquad"] as const;
export type Team = (typeof TEAMS)[number];

// A Feature the form offers, and the team its tickets go to. A retired one is hidden from the form but still routes old tickets.
export interface FeatureEntry {
  label: string;
  team: Team;
  retired?: boolean;
}

// What the form offers until an admin saves a list of their own: the 12 features of the form this replaces and the others the master Sheet's teams used,
// each with the team that worked most of its tickets. Spelling variants are merged, and the Sheet's "Miscellaneous" is "Other".
// Each needs an option of the same name on the Slack List's Feature column.
export const DEFAULT_FEATURES: readonly FeatureEntry[] = [
  { label: "Admin Users", team: "Platform" },
  { label: "Agreement Summary", team: "ShareSquad" },
  { label: "All Documents", team: "Platform" },
  { label: "All option agreements page", team: "StatSquad" },
  { label: "Annual Notifications", team: "ShareSquad" },
  { label: "Articles of Association", team: "CoCo" },
  { label: "Audit Trail", team: "CoCo" },
  { label: "Bespoke Agreements", team: "ShareSquad" },
  { label: "Bespoke Resolutions", team: "Platform" },
  { label: "Bulk Stock Transfer", team: "ShareSquad" },
  { label: "Business Document templates", team: "Platform" },
  { label: "Cap Table", team: "StatSquad" },
  { label: "Communication", team: "CoCo" },
  { label: "Companies House filings", team: "CoCo" },
  { label: "Company Settings", team: "CoCo" },
  { label: "Conditional Shares", team: "ShareSquad" },
  { label: "Confirmation Statements", team: "CoCo" },
  { label: "Convertibles", team: "Platform" },
  { label: "CSOP", team: "ShareSquad" },
  { label: "Data Rooms", team: "Platform" },
  { label: "Directors", team: "CoCo" },
  { label: "Dividends", team: "CoCo" },
  { label: "Document signing", team: "Platform" },
  { label: "EMI", team: "ShareSquad" },
  { label: "ESU", team: "Platform" },
  { label: "Exercising Options", team: "ShareSquad" },
  { label: "Governance", team: "CoCo" },
  { label: "Growth Shares", team: "ShareSquad" },
  { label: "Help Modal", team: "Platform" },
  { label: "HR Integration", team: "Platform" },
  { label: "ID Checks", team: "CoCo" },
  { label: "IFRS2", team: "StatSquad" },
  { label: "Incorporations", team: "CoCo" },
  { label: "Initial Notifications", team: "ShareSquad" },
  { label: "Investment area", team: "CoCo" },
  { label: "Investment Round (InVestd)", team: "CoCo" },
  { label: "Investment round modelling", team: "CoCo" },
  { label: "Investor Account", team: "CoCo" },
  { label: "Investor Self Certification", team: "CoCo" },
  { label: "Joining Flow", team: "Platform" },
  { label: "Legal Owner Register", team: "ShareSquad" },
  { label: "Legal/Beneficial Owner", team: "ShareSquad" },
  { label: "My Equity", team: "StatSquad" },
  { label: "Navigation", team: "StatSquad" },
  { label: "Nominal Value", team: "ShareSquad" },
  { label: "Off Platform Share Issuance", team: "ShareSquad" },
  { label: "Onboarding Page", team: "CoCo" },
  { label: "Payments", team: "Platform" },
  { label: "Phantom Options", team: "ShareSquad" },
  { label: "Processing a Leaver", team: "ShareSquad" },
  { label: "PSC Verification Statement", team: "CoCo" },
  { label: "PSCs", team: "CoCo" },
  { label: "Recipient Bulk Upload", team: "Platform" },
  { label: "Recipient Dashboard", team: "ShareSquad" },
  { label: "Reporting", team: "StatSquad" },
  { label: "Resolutions", team: "CoCo" },
  { label: "SEIS/EIS", team: "CoCo" },
  { label: "Share authorisations", team: "ShareSquad" },
  { label: "Share Buybacks", team: "ShareSquad" },
  { label: "Share certificates", team: "ShareSquad" },
  { label: "Share classes", team: "ShareSquad" },
  { label: "Share Conversions", team: "ShareSquad" },
  { label: "Share History Upload", team: "ShareSquad" },
  { label: "Share Issuance", team: "ShareSquad" },
  { label: "Share movement history", team: "ShareSquad" },
  { label: "Share pools/Option pools", team: "ShareSquad" },
  { label: "Shareholder Dashboard", team: "StatSquad" },
  { label: "Shareholder Record", team: "CoCo" },
  { label: "Shareholders", team: "CoCo" },
  { label: "Single Sign On", team: "Platform" },
  { label: "SPV", team: "CoCo" },
  { label: "Stock Transfers", team: "ShareSquad" },
  { label: "Subdivision", team: "ShareSquad" },
  { label: "Unapproved Options", team: "ShareSquad" },
  { label: "Valuations", team: "ShareSquad" },
  { label: "Other", team: "Platform" },
];

// A ticket with no Feature, or one the list no longer knows, goes to Platform.
export function teamForFeature(feature: string | undefined, features: readonly FeatureEntry[] = DEFAULT_FEATURES): Team {
  return (feature ? features.find((entry) => entry.label === feature)?.team : undefined) ?? "Platform";
}
